const initialState = {
  token: null,
  activeGame: null,
}

export default initialState;